export const FEATURE_NAME = '@zerops/zerops/feature/code-server-overlay';
